import { Box, Typography, Button, useTheme } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const Unauthorized = () => {
    const navigate = useNavigate();
    const theme = useTheme();


    const blobVariants = {
        animate: {
            y: [0, -40, 0],
            x: [0, 20, 0],
            scale: [1, 1.1, 1],
            transition: {
                duration: 8,
                repeat: Infinity,
                ease: "easeInOut"
            }
        }
    };

    const blobVariants2 = {
        animate: {
            y: [0, 40, 0],
            x: [0, -30, 0],
            scale: [1, 1.2, 1],
            transition: {
                duration: 10,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 1
            }
        }
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                position: 'relative',
                overflow: 'hidden',
                // backgroundColor: 'background.default',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                component={motion.div}
                variants={blobVariants}
                animate="animate"
                sx={{
                    position: 'fixed',
                    width: '50vw',
                    height: '50vw',
                    borderRadius: '50%',
                    background: `radial-gradient(circle, ${theme.palette.primary.light} 0%, rgba(255,255,255,0) 70%)`,
                    opacity: 0.4,
                    filter: 'blur(60px)',
                    zIndex: 0,
                }}
            />
            <Box
                component={motion.div}
                variants={blobVariants2}
                animate="animate"
                sx={{
                    position: 'absolute',
                    bottom: '-10%',
                    right: '-5%',
                    width: '45vw',
                    height: '45vw',
                    borderRadius: '50%',
                    background: `radial-gradient(circle, ${theme.palette.secondary.light} 0%, rgba(255,255,255,0) 70%)`,
                    opacity: 0.3,
                    filter: 'blur(60px)',
                    zIndex: 0,
                }}
            />

            <Box
                component={motion.div}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    width: '100%',
                    maxWidth: '500px',
                    background: 'rgba(255, 255, 255, 0.65)',
                    backdropFilter: 'blur(20px)',
                    borderRadius: 4,
                    p: 6,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
                    border: '1px solid rgba(255, 255, 255, 0.18)',
                    mx: 2,
                }}
            >
                <motion.div
                    animate={{ y: [0, -15, 0] }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                >
                    <LockIcon sx={{ fontSize: 100, color: 'primary.main', mb: 3 }} />
                </motion.div>

                <Typography
                    variant="h1"
                    component="h1"
                    gutterBottom
                    sx={{
                        background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                        backgroundClip: 'text',
                        textFillColor: 'transparent',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        mb: 1
                    }}
                >
                </Typography>

                <Typography variant="h4" component="h2" gutterBottom sx={{ color: 'text.primary', fontWeight: 600, mb: 2 }}>
                    Access Denied
                </Typography>

                <Typography variant="body1" color="textSecondary" paragraph sx={{ mb: 4, fontSize: '1rem' }}>
                    Sorry, you don't have permission to access this area. <br />
                    Let's get you back to safety.
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate('/', { state: { fromUnauthorized: true } })}
                    sx={{
                        px: 4,
                        py: 1,
                        fontSize: '1.1rem',
                    }}
                >
                    Go to Home
                </Button>
            </Box>
        </Box>
    );
};

export default Unauthorized;
